'use client';

import Link from 'next/link';
import { useState } from 'react';
import { useConfig } from './ConfigProvider';

/**
 * Discovery-oriented navbar for the ComusLive portal.
 * No "Tarifs" (that's a ComusFlow/SaaS concern); instead an outbound link for
 * venues who want to publish their events via ComusFlow.
 */
export function Navbar() {
  const { comusflowUrl } = useConfig();
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg border-bottom bg-body-tertiary">
      <div className="container">
        <Link href="/" className="navbar-brand fw-bold">
          <i className="bi bi-broadcast-pin me-2"></i>
          ComusLive
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`navbar-collapse${open ? ' show' : ' collapse'}`} id="publicNav">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <Link href="/events" className="nav-link">
                Événements
              </Link>
            </li>
            <li className="nav-item">
              <a href={comusflowUrl} className="btn btn-outline-primary btn-sm ms-lg-2">
                <i className="bi bi-building me-1"></i>
                Vous gérez une salle&nbsp;?
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
